import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { environment } from 'src/environments/environment';

const AUTH_PATH_URL = 'v1/widget/auth';
const AUTH_CHECK_TIMEOUT_MS = 30_000;

@Injectable({
  providedIn: 'root',
})
export class StoreAuthorizationService {
  constructor(
    private http: HttpClient,
    private companyStateService: CompanyStateService,
  ) {}

  check(productCode: string): Promise<boolean> {
    const params = new HttpParams()
      .set('cid', this.companyStateService.getSelectedCompanyId())
      .set('pc', productCode)
      .set('startTrial', 'false');

    return firstValueFrom(
      this.http
        .get<{
          authorized: boolean;
        }>(environment.STORE_SERVER_URL + AUTH_PATH_URL, { params })
        .pipe(timeout(AUTH_CHECK_TIMEOUT_MS)),
    )
      .then((response) => {
        if (response.authorized) {
          return true;
        }
        return Promise.reject(false);
      })
      .catch((error) => {
        if (error === false) {
          return Promise.reject(false);
        }
        console.error('Failed to check store authorization.', error);
        return Promise.reject(error);
      });
  }
}
